export const status =[
	{
		'id': 1,
		'name': 'Đã hoàn thành'
	},
	{
		'id' : 2,
		'name': 'Chưa hoàn thành'
	}
]